import styled from "styled-components";
import { orange } from "../../styles/variables.style";

export const NousWrapper = styled.div`
  &:nth-child(even) {
    background: white;
  }
  .img_team {
    img {
      clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
      width: 100%;
      height: 500px;
      object-fit: cover;
    }
    h1 {
      position: absolute;
      width: 100%;
      z-index: 1;
      padding-top: 130px;
      padding-bottom: 230px;
      font-weight: bold;
      text-align: center;
      font-size: 100px;
      color: white;
    }
  }
  .filters {
    justify-content: center;
    .ant-btn {
      ${"" /* margin-left: 100px; */}
      ${"" /* margin-right: 100px; */}
      border-radius: 30px;
      padding-left: 50px;
      padding-right: 50px;
    }
    img {
      width: 180px;
      margin-top: -5px;
      cursor: pointer;
      &:hover {
        filter: grayscale(0.5);
      }
    }
  }
  .collaboratorsTitle {
    text-align: center;
    font-weight: bold;
    font-size: 32px;
    display: flex;
    justify-content: center;
    img {
      width: 200px;
    }
  }
  .collaboratorsRow {
    width: 100px;
    margin-bottom: 30px;
  }
  .collaboratorsWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-left: 20%;
    padding-right: 20%;
    margin-bottom: 20px;
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      &.two {
        width: 50%;
        &.left {
          padding-left: 15%;
        }
        &.right {
          padding-right: 15%;
        }
      }
      &.three {
        width: 33%;
      }
      img,
      svg {
        border-radius: 50%;
        width: 150px;
        height: 150px;
        object-fit: cover;
        &.ghita {
          object-position: 0px -25px;
        }
      }
      p,
      a {
        text-align: center;
        margin: 0px;
        font-weight: bold;
        &.name {
          color: ${orange};
        }
      }
    }
  }
  .section2 {
    margin-left: 30%;
    margin-right: 30%;
    margin-top: 50px;
    margin-bottom: 100px;
    .txt {
      margin-bottom: 50px;
      color: #788896;
      font-size: 20px;
    }
    .btn {
      margin-left: auto;
      margin-right: auto;
      border-radius: 30px;
      background: #4ca6e2;
      height: 40px;
      padding: 3%;
      font-size: 20px;

      &:hover {
        font-weight: normal;
        color: white;
      }
    }
  }
  .section3 {
    padding-left: 8%;
    padding-right: 8%;
    background: #80dd93;
    display: flex;
    .gauche {
      flex: 1;
      padding-top: 40px;
      span {
        max-width: 100%;
        margin-left: 50px;
        margin-bottom: -5px !important; 
      }
    }
    .droite {
      flex: 2;

      padding-left: 5%;
      .title {
        font-weight: bold;
        font-size: 30px;
        margin-bottom: 30px;
        padding-top: 50px;
      }
      .txt {
        font-size: 18px;
        text-align: justify;
      }
    }
  }
  .blocs {
    > div {
      padding-left: 15%;
      padding-right: 15%;
    }
  }
  .jobs {
    background: #93c9ed;

    padding-bottom: 50px;
    padding-top: 20px;
    text-align: center;

    .title {
      font-size: 30px;
      color: black;
      font-weight: bold;
    }
    .txt {
      font-size: 30px;
    }
    .btn {
      margin-left: auto;
      margin-right: auto;
      border-radius: 20px;
      font-size: 25px;
      background: #ffa400;
      height: 50px;

      margin-top: 20px;
      &:hover {
        color: white;
        font-weight: normal;
      }
    }
  }

  @media (max-width: 1024px) {
    .img_team {
      background-position: 50% 0%;
      background-size: cover;
      background-position: 39% 0px, 50% 100%;
      background-size: 290%, cover;
      h1 {
        position: relative;
        font-size: 30px;
        color: black;
        padding: 0px;
        padding-top: 50px;
        padding-left: 15px;
        text-align: left;
      }
    }
    .filters {
      margin: 0px;
      .ant-select {
        width: 90%;
      }
      .ant-select-selection-item {
        img {
          width: 80px;
        }
      }
    }
    .section2 {
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 0px;
      margin-bottom: 50px;
    }
    .section3 {
      flex-direction: column;
      padding-left: 10px;
      padding-right: 10px;
      .title {
        font-size: 25px !important;
      }
      .droite {
        padding-left: 0px;
        padding-bottom: 20px;
      }
    }
    .blocs {
      > div {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
    .txt {
      font-size: 17px !important;
    }
    .collaboratorsWrapper {
      padding: 0px;
      > div {
        width: 50%;
      }
      img,
      svg {
        width: 100px !important;
        height: 100px !important;
      }
      a,
      p {
        font-size: 10px;
      }
    }
  }
`;
